<template>
    <b-modal
      id="mainRegistration"
      modal-class="modal-cover"
      v-model="isVisible"
      hide-footer
      content-class="shadow-lg"
      centered
    >

  <!-- <b-modal hide-footer centered v-model="isVisible"> -->
    
  <!-- Modal -->
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-body">
          <div class="trip-login-wrap" :dir="isHebrew ? 'rtl' : 'ltr'">
            <h2 class="access-with-title">{{ t('accessWith') }}</h2>
            <div class="social-login-buttons">
              <button 
                class="social-login-btn google-btn"
                @click="loginToAppWithGoogle">
                <img 
                  src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/icons%2Flog_in%2Fgoogle.png?alt=media&token=60857ff1-650c-464f-861b-2aabdcb78df7" 
                  alt="Google"
                  class="social-icon"
                >
                <span>{{ t('continueWithGoogle') }}</span>
              </button>
            </div>
            <div class="trip-border-content">
              <p>{{ t('orRegisterWith') }}</p>
            </div>
            <form action="#">
              <div class="trip-login-field">
                <b-form-input
                  @input="updateUserName"
                  autocapitalize="none"
                  :placeholder="t('usernamePlaceholder')"
                  :class="['log_in_medium', isHebrew ? 'text-right' : 'text-left']"
                  type="text">
                </b-form-input>
              </div>
              <div class="trip-login-field">
                <b-form-input
                  dir="ltr"
                  autocapitalize="none"
                  :value="email"
                  @input="updateEmail"
                  id="email"
                  :placeholder="t('emailPlaceholder')"
                  :class="['log_in_medium', isHebrew ? 'text-right' : 'text-left']"
                  required>
                </b-form-input>
              </div>
              <div class="trip-login-field">
                <b-form-input
                  :value="password"
                  autocapitalize="none"
                  @input="updatePassword"
                  :placeholder="t('passwordPlaceholder')"
                  :class="['log_in_medium', isHebrew ? 'text-right' : 'text-left']"
                  type="password">
                </b-form-input>
              </div>
              <div class="trip-login-field">
                <b-form-input
                  :value="rePassword"
                  autocapitalize="none"
                  @input="updateRePassword"
                  :placeholder="t('confirmPasswordPlaceholder')"
                  :class="['log_in_medium', isHebrew ? 'text-right' : 'text-left']"
                  type="password">
                </b-form-input>
              </div>
              <div v-if="registrationErrorMessage" class="registration-error-message">
                {{ registrationErrorMessage }}
              </div>
              <div class="trip-login-check" :dir="isHebrew ? 'rtl' : 'ltr'">
                <input type="checkbox" id="html">
                <label for="html">
                  <b-link 
                    @click="goToTermsOfUse">
                    {{ t('readTerms') }}
                  </b-link>
                </label>
                <h5>{{ t('agreeToTerms') }}</h5>
              </div>
              <button
                id="trip-login-btn2"
                type="button"
                @click="newUserRegistration">
                {{ t('registerButton') }}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- End modal -->    
    
  </b-modal>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';

export default {
  mixins: [translationMixin],
  props: ["value"],
  data() {
    return {
      registrationErrorMessage: ''
    };
  },
  computed: {
     ...mapGetters([  'email',
                      'password',
                      'rePassword',
                      'userName',
                      'isNewUser']),
    isVisible: {
      set(val) {
        this.$emit("input", val);
      },
      get() {
        return this.value;
      },
    },
  },
  methods: 
  {
    ...mapActions(['register',
                   'registerNewUser',
                   'validateAndupdateAppToken',
                   'goToTermsOfUse',
                   'loginToAppWithGoogle',
                   'showModalWithParameters']),
    validateEmail(email) {
      // Remove any whitespace from the email
      const trimmedEmail = email.trim();
      
      // Check if email contains spaces after trimming
      if (trimmedEmail.includes(' ')) {
        this.showModalWithParameters({
          errorNumber: 'invalid_email_spaces',
          type: 'textConverter'
        });
        return false;
      }
      
      // Basic email validation regex
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(trimmedEmail)) {
        this.showModalWithParameters({
          errorNumber: 'invalid_email_format',
          type: 'textConverter'
        });
        return false;
      }
      
      return true;
    },
    updateEmail(value) {
      // Just update the store value, no validation
      this.$store.commit('setEmail', value);
    },
    newUserRegistration() {
      // Clear previous error messages
      this.registrationErrorMessage = '';

      // Validate email before proceeding with registration
      if (!this.validateEmail(this.email)) {
        return;
      }

      // Check if password is empty
      const password = this.password;
      if (!password || !password.trim()) {
        this.registrationErrorMessage = this.t('mainRegistrationEnterPassword');
        return;
      }

      // Check password match
      const rePassword = this.rePassword;
      if (password != rePassword) {
        this.registrationErrorMessage = this.t('mainRegistrationPasswordMismatch');
        this.$store.commit('setRePassword', '');
        this.$store.commit('setPassword', '');
        return;
      }

      // Trim the email before sending to the server
      this.$store.commit('setEmail', this.email.trim());

      // Proceed with registration
      this.$store.dispatch('registerNewUser');
      this.$store.dispatch('showModal', "");
    },
    updateUserName (value) {
      this.$store.commit('setUserName', value)
    },
    updatePassword (value) {
      this.$store.commit('setPassword', value)
      // Clear error message when user starts typing
      if (this.registrationErrorMessage) {
        this.registrationErrorMessage = '';
      }
    },
    updateRePassword (value) {
      this.$store.commit('setRePassword', value)
      // Clear error message when user starts typing
      if (this.registrationErrorMessage) {
        this.registrationErrorMessage = '';
      }
    },
  },

};
</script>
<style scoped>
/* modal */
.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 40px 30px;
}
.modal-dialog {
  max-width: 400px;
  margin: 1.75rem auto!important;
  margin-top: 10%!important;
}
.modal-content {
  background: #FFFFFF;
  box-shadow: 4px 4px 4px rgb(0 0 0 / 10%);
  border-radius: 25px;
}
.trip-login-wrap{
  text-align: center;
}
.trip-login-wrap > * {
  margin-bottom: 10px;
}
.trip-login-wrap > *:last-child {
  margin-bottom: 0;
}

.access-with-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;
  color: #2E2E3A;
  margin-bottom: 30px;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.social-login-buttons {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.social-login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  width: 100%;
  height: 48px;
  border: 1px solid #E0E0E0;
  border-radius: 4px;
  background: #FFFFFF;
  font-weight: 500;
  font-size: 14px;
  color: #2E2E3A;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0 20px;
}

.social-login-btn:hover {
  background: #F5F5F5;
  border-color: #C0C0C0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.social-login-btn:active {
  transform: scale(0.98);
}

.social-icon {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}

.google-btn {
  border-color: #4285F4;
  color: #1f3d7a;
}

.google-btn:hover {
  background: #E8F0FD;
  border-color: #4285F4;
}

.trip-login-wrap[dir="rtl"] .social-login-buttons {
  direction: rtl;
}

.trip-login-wrap[dir="rtl"] .social-login-btn {
  flex-direction: row-reverse;
  text-align: right;
}

.trip-login-wrap[dir="rtl"] .social-login-btn span {
  text-align: right;
}

.trip-login-wrap[dir="rtl"] .social-icon {
  margin-left: 0;
  margin-right: 0;
}

.trip-login-field{
  margin-bottom: 10px;
}
.trip-login-field input{
  height: 48px;
  width: 100%;
  border: 1px solid #C1C0C0;
  border-radius: 4px;
  font-size: 16px;
  line-height: 22px;
  padding: 12px 15px!important;
  color: black;
}

.trip-login-field input.text-right {
  text-align: right;
}

.trip-login-field input.text-left {
  text-align: left;
}
button#trip-login-btn, 
button#trip-login-btn2 {
  width: 100%;
  height: 48px;
  background: #2E2E3A;
  border-radius: 4px;
  border: none;
  font-weight: 500;
  font-size: 14px;
  color: white;
  margin-top: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}
button#trip-login-btn2{
  background-color:  #2E2E3A;
}
button#trip-login-btn2:hover {
  background: #1a1a24;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.trip-login-wrap h3{
  font-weight: 800;
  font-size: 18px;
  line-height: 21px;
  color: #2E2E3A;
  margin-bottom: 15px;
  text-align: center
}
.trip-border-content{
  text-align: center;
  margin-top: 20px;
  margin-bottom: 12px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.trip-border-content p{
  font-weight: 400;
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
  text-align: center;
  position: relative;
  z-index: 2;
  background-color: #fff;
  padding: 0 25px;
  margin: 0;
  white-space: nowrap;
  display: inline-block;
}
.trip-border-content p:before, 
.trip-border-content p:after {
  content: "";
  position: absolute;
  top: 50%;
  width: 15%;
  height: 1px;
  background-color: #2E2E3A;
  z-index: 0;
}
.trip-border-content p:before {
  left: 0;
}
.trip-border-content p:after {
  right: 0;
}
.trip-login-bottom-btn{
  margin-top: 25px;
}
.trip-login-bottom-btn h5{
  font-size: 14px;
  line-height: 12px;
  color: #2E2E3A;
  margin-bottom: 5px;
}

button.trip-login-btn {
  font-weight: 500;
  font-size: 12px;
  line-height: 14px;
  color: #FFFFFF;
  width: 129px;
  height: 30px;
  background: #07A0C3;
  border-radius: 22px;
  border: none;
}
.trip-login-check {
  text-align: right;
}
.trip-login-check h5{
  font-size: 9px;
  line-height: 11px;
  text-align: right;
  color: #2E2E3A;
  margin-top: 7px;
}
.trip-login-check label{
  font-size: 10px;
  line-height: 12px;
  color: #2E2E3A;
}
.trip-login-check input {
  padding: 0;
  height: initial;
  width: initial;
  margin-bottom: 0;
  display: none;
  cursor: pointer;
}

.trip-login-check label {
  position: relative;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  flex-direction: row;
}

.trip-login-check label:before {
  content:'';
  -webkit-appearance: none;
  appearance: none;
  background-color: transparent;
  border: 1px solid #2E2E3A;
  box-shadow: 0 0 0 1px transparent;
  width: 15px;
  height: 15px;
  min-width: 15px;
  min-height: 15px;
  display: inline-block;
  position: relative;
  cursor: pointer;
  border-radius: 3px;
  vertical-align: middle;
}

.trip-login-check input:checked + label:after {
  content: '';
  display: block;
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 8px;
  border: solid #2E2E3A;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
  pointer-events: none;
}

/* contact page */
.trip-card-top.trip-card-top2{
  text-align: left;
  position: relative;
}
.trip-card-top h4 {
  font-weight: 600;
  font-size: 30px;
  line-height: 41px;
  color: #0D2F29;
  display: inline-block;
  position: absolute;
  top: 0;
  margin: 0;
  left: 50%;
  transform: translateX(-50%);
}
.trip-contact-wrap h4{
  display: none;
}
.trip-contact-field {
  margin-bottom: 15px;
}
.trip-contact-field label{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: #110703;
  display: block;
  margin-bottom: 5px;
  margin-right: 40px;
  }
  .trip-contact-field label span{
    color: #E42424;
  }
  
  .trip-contact-input{
    position: relative;
  }
  .trip-contact-field img{
    width: 100%;
  }
  .trip-contact-input input, 
  .trip-contact-input textarea{
    height: 56px;
    width: 100%;
    background: #FFFFFF;
    border: 2px solid #07A0C3!important;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: right;
    padding: 10px 50px 10px 160px!important;
    color: rgba(13, 47, 41, 0.5)!important;

  }
  .trip-contact-input textarea{
    height: 300px;
  }
  .trip-input-icon {
    position: absolute;
    top: 13px;
    right: 25px;
  }
  .trip-contact-input p{
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    margin:15px 0 0;
    color: rgba(228, 36, 36, 0.6)
  }
.trip-contact-input input::-webkit-input-placeholder, 
.trip-contact-input textarea::-webkit-input-placeholder{ /* WebKit, Blink, Edge */
    color: rgba(13, 47, 41, 0.5);
    opacity: 1;
}
.trip-contact-input input:-moz-placeholder, 
.trip-contact-input textarea:-moz-placeholder{ /* Mozilla Firefox 4 to 18 */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input::-moz-placeholder, 
.trip-contact-input textarea::-moz-placeholder{ /* Mozilla Firefox 19+ */
  color: rgba(13, 47, 41, 0.5);
   opacity:  1;
}
.trip-contact-input input:-ms-input-placeholder, 
.trip-contact-input textarea:-ms-input-placeholder{ /* Internet Explorer 10-11 */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}
.trip-contact-input input::-ms-input-placeholder, 
.trip-contact-input textarea::-ms-input-placeholder{ /* Microsoft Edge */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

.trip-contact-input input::placeholder, 
.trip-contact-input textarea::placeholder{ /* Most modern browsers support this now. */
  color: rgba(13, 47, 41, 0.5);
   opacity: 1;
}

button#submit-btn1 {
  height: 56px;
  background: #0D2F29;
  border-radius: 12px;
  width: 100%;
  font-weight: 700;
  font-size: 20px;
  line-height: 27px;
  text-align: center;
  color: #FFFFFF;
}
button#submit-btn2 {
    width: 188px;
    height: 42px;
    background: #DD6E42;
    border-radius: 45px;
    font-weight: 700;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
    border: none;
    margin: 0 auto;
}

.trip-submit-button{
  margin-top: 50px;
  text-align: center;
}

.trip-contact-form-section {
  padding-bottom: 150px;
}
.trip-contact-siderbar{
  background: rgba(225, 246, 251, 0.5);
  border-radius: 18px;
  padding: 25px;
  margin-left: 50px;
}
.trip-contact-siderbar h5{
  font-weight: 700;
  font-size: 18px;
  line-height: 24px;
  text-align: center;
  color: #E42424;
}

.trip-card2-thumb-resposive {
  display: none;
}
.trip-card2-thumb-resposive img{
  width: 100%;
  height: 100%;
}

.close-icon {
  border: 1px solid transparent;
  background-color: transparent;
  display: inline-block;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
  position: absolute;
  left: 13px;
  top: 13px;
  font-weight: 800;
  font-size: 18px;
  line-height: 24px;
  text-align: right;
  color: #FF0000;
}
.close-icon img{
  width: auto;
}
.input-remove:not(:valid) ~ .close-icon {
	display: none;
}

/* Language-specific styles */
.trip-login-wrap[dir="rtl"] {
  text-align: right;
}

.trip-login-wrap[dir="ltr"] {
  text-align: left;
}

.trip-login-wrap[dir="ltr"] h3,
.trip-login-wrap[dir="ltr"] h5,
.trip-login-wrap[dir="ltr"] p {
  text-align: center;
}

.trip-login-wrap[dir="rtl"] h3,
.trip-login-wrap[dir="rtl"] h5,
.trip-login-wrap[dir="rtl"] p {
  text-align: center;
}

/* Keep social login buttons centered for both languages */
.login-o-ath {
  text-align: center !important;
  direction: ltr;
}

.trip-google-btn {
  display: inline-block;
}

/* Keep the "or register with" divider centered */
.trip-border-content {
  text-align: center !important;
  direction: ltr;
}

/* Language toggle positioning */
.language-toggle-container {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 10;
}

/* Customize language toggle for modal */
.language-toggle-container .language-toggle .language-btn {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid #e2e8f0;
  border-radius: 20px;
  padding: 4px 8px;
  font-size: 12px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.language-toggle-container .language-toggle .language-btn:hover {
  background: rgba(255, 255, 255, 1);
  border-color: #34D0B6;
}

/* Language-aware checkbox section alignment */
.trip-login-check[dir="rtl"] {
  text-align: right;
}

.trip-login-check[dir="ltr"] {
  text-align: left;
}

/* Language-aware checkbox spacing */
.trip-login-check[dir="rtl"] label {
  flex-direction: row;
}

.trip-login-check[dir="rtl"] label:before {
  margin-left: 20px;
  margin-right: 0;
}

.trip-login-check[dir="ltr"] label {
  flex-direction: row;
}

.trip-login-check[dir="ltr"] label:before {
  margin-left: 0;
  margin-right: 20px;
}

/* Adjust checkmark position for RTL */
.trip-login-check[dir="rtl"] input:checked + label:after {
  left: auto;
  right: 5px;
}

/* Registration error message */
.registration-error-message {
  margin-top: 10px;
  margin-bottom: 10px;
  padding: 12px 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  border: 2px solid rgba(220, 53, 69, 0.3);
  text-align: center;
}




</style>